/* global resetAccessibleMessage:false */
/* global setAccessibleMessage:false */
/* global trigger:false */

function shakeForm(form) {
	form.classList.add('shake-animation');

	setTimeout(function() {
		form.classList.remove('shake-animation');
	}, 1000);
}



function makeFieldsDisabled(form) {
	const formFields = form.querySelectorAll('input, textarea, select');

	Array.prototype.forEach.call(formFields, function(formField) {
		formField.setAttribute('disabled', 'disabled');
	});
}



function makeFieldsEnabled(form) {
	const formFields = form.querySelectorAll('input, textarea, select');

	Array.prototype.forEach.call(formFields, function(formField) {
		formField.removeAttribute('disabled');
	});
}



function sendFormData(form) {
	const nameField = form.querySelector('.js-input-name');
	const emailField = form.querySelector('.js-input-email');
	const phoneField = form.querySelector('.js-input-phone');
	const fromToField = form.querySelector('.js-input-from-to');
	const timeFromField = form.querySelector('.js-input-time-from');
	const roomNumberField = form.querySelector('.js-input-room-number');
	const peopleCountField = form.querySelector('.js-input-people-count');
	const companyField = form.querySelector('.js-input-company');
	const invoicingAddressField = form.querySelector('.js-input-invoicing-address');
	const icField = form.querySelector('.js-input-ic');
	const dicField = form.querySelector('.js-input-dic');
	const notesField = form.querySelector('.js-input-notes');
	const submitButton = form.querySelector('.js-submit-button');
	var submitButtonText = submitButton.innerText;

	var data = {
		name: nameField.value,
		email: emailField.value,
		phone: phoneField.value,
		fromTo: fromToField.value,
		timeFrom: timeFromField.value,
		roomNumber: roomNumberField.value,
		peopleCount: peopleCountField.value,
		company: companyField.value,
		invoicingAddress: invoicingAddressField.value,
		ic: icField.value,
		dic: dicField.value,
		notes: notesField.value.trim(),
	};

	submitButton.disabled = true;
	submitButton.innerText = 'Odesílám ...';

	const prepareResponseOverlayAfterSubmit = function() {
		form.querySelector('.js-submit-response').classList.add('form-response--show-overlay');
		form.querySelector('.js-submit-response-messages').style.display = '';
		form.querySelector('.js-submit-response-messages').focus();
		window.scrollTo(0, 500);
	};

	const handleErrorState = function() {
		var message = form.querySelector('.js-submit-response-error');
		setAccessibleMessage(message, 'alert');
		message.style.display = '';
		shakeForm(form);
	};

	const resetErrorMessages = function() {
		var message = form.querySelector('.js-submit-response-error');
		resetAccessibleMessage(message);
		message.style.display = 'none';
	};

	const handleSuccessState = function() {
		var message = form.querySelector('.js-submit-response-confirmation');
		setAccessibleMessage(message);
		message.style.display = '';
		form.setAttribute('data-submitted', 'true');
	};

	var request = new XMLHttpRequest();
	request.open('POST', 'https://hook.eu1.make.com/v9on8x7o3pdj2ttoymwkqvgg9i8wxwsc', true);
	request.timeout = 40000;
	request.setRequestHeader('Content-Type', 'application/json');

	request.onerror = function() {
		submitButton.disabled = false;
		submitButton.innerText = submitButtonText;
		handleErrorState();
	}

	request.ontimeout = function() {
		submitButton.disabled = false;
		submitButton.innerText = submitButtonText;
		handleErrorState();
	}

	request.onreadystatechange = function() {
		// Request finished. Do processing here.
		if (this.response && this.readyState === XMLHttpRequest.DONE) {
			resetErrorMessages();
			submitButton.disabled = false;
			submitButton.innerText = submitButtonText;

			if (this.status === 200) {
				if (this.response === 'Accepted') {
					prepareResponseOverlayAfterSubmit();
					handleSuccessState();

					// we need to delay disabling of field to do that at the moment
					// once we will have visible overlay
					setTimeout(function() {
						makeFieldsDisabled(form);
						form.reset();
					}, 500);
				} else {
					handleErrorState();
				}
			} else {
				handleErrorState();
			}
		}
	}

	request.send(JSON.stringify(data));
}



/**
 * Submit contact form
 */

var bookingForms = document.querySelectorAll('.js-booking-form');
for (var i = 0 ; i < bookingForms.length; i++) {
	var bookingForm = bookingForms[i];

	bookingForm.setAttribute('data-submitted', 'false');

	bookingForm.addEventListener('formvalid', (ev) => {
		const details = ev.detail;
		const formEl = details.formElement;

		var isSubmitted = formEl.getAttribute('data-submitted') && formEl.getAttribute('data-submitted') == 'true';

		if (isSubmitted) {
			return false;
		}

		sendFormData(formEl);
	});

	bookingForm.addEventListener('submit', (ev) => {
		ev.preventDefault();

		return false;
	});
}



/**
 * Toggle invoicing details
 */

var toggleInvoicingDetailsElem = document.querySelectorAll('.js-input-invoicing-details-toggle');
var invoicingDetailsElems = document.querySelectorAll('.js-invoicing-details');
if (invoicingDetailsElems.length > 0) {
	toggleInvoicingDetailsElem[0].addEventListener('change', (event) => {
		for (var i = 0 ; i < invoicingDetailsElems.length; i++) {
			var invoicingDetailsElem = invoicingDetailsElems[i];
			const formFields = invoicingDetailsElem.querySelectorAll('input, textarea, select');

			if (event.currentTarget.checked) {
				invoicingDetailsElem.style.display = '';
				Array.prototype.forEach.call(formFields, function(formField) {
					formField.removeAttribute('data-validate-ignore');
				});
			} else {
				invoicingDetailsElem.style.display = 'none';
				Array.prototype.forEach.call(formFields, function(formField) {
					formField.setAttribute('data-validate-ignore', 'true');
				});
			}
		}
	});
}
